import { IFilterOptionDef } from 'ag-grid-enterprise';

const filterModelTypeToBackendOperator :Record<string, string> = {
  equals: 'eq',
  notEqual: 'neq',
  lessThan: 'lt',
  greaterThan: 'gt',
  lessThanOrEqual: 'lte',
  greaterThanOrEqual: 'gte',
  inRange: 'between',
  contains: 'like',
};

const AdvancedFilterOperatorByAgGridType = {
  equals: 'eq',
  notEqual: 'neq',
  lessThan: 'lt',
  greaterThan: 'gt',
  lessThanOrEqual: 'lte',
  greaterThanOrEqual: 'gte',
  hasAny: 'in',
  notHasAny: 'notin',
  in: 'in',
  notIn: 'notin',
  blank: 'notset',
  notBlank: 'set',
  contains: 'contains',
  notContains: 'notcontains',
};

const DEFAULT_DETAIL_CELL_RENDERER_TEMPLATE = `
  <div class="lum-ag-details">
    <div
      ref="eDetailGrid"
      class="ag-theme-alpine ag-theme-lum ag-theme-lum--next  lum-ag-details__content"
    ></div>
  </div>
`;

const FilterOption :{ [key :string] :IFilterOptionDef } = {
  HAS_ALL: {
    displayKey: 'hasAll',
    displayName: 'Has all of',
    numberOfInputs: 1,
    predicate: (filterValues, cellValue) :boolean =>
      filterValues[0]
        .split(',')
        .map((v) => v.trim())
        .every((value) => cellValue.includes(value)),
  },
  NOT_HAS_ALL: {
    displayKey: 'notHasAll',
    displayName: 'Has not all of',
    numberOfInputs: 1,
    predicate: (filterValues, cellValue) :boolean =>
      filterValues[0]
        .split(',')
        .map((v) => v.trim())
        .every((value) => !cellValue.includes(value)),
  },
  // For when the cell value is a comma-separated list.
  HAS_ANY: {
    displayKey: 'hasAny',
    displayName: 'Has any of',
    numberOfInputs: 1,
    predicate: (filterValues, cellValue) :boolean =>
      filterValues[0]
        .split(',')
        .map((v) => v.trim())
        .some((value) => cellValue.includes(value)),
  },
  NOT_HAS_ANY: {
    displayKey: 'notHasAny',
    displayName: 'Has none of',
    numberOfInputs: 1,
    predicate: (filterValues, cellValue) :boolean =>
      filterValues[0]
        .split(',')
        .map((v) => v.trim())
        .some((value) => !cellValue.includes(value)),
  },

  // For when the cell value is a single value.
  IN: {
    displayKey: 'in',
    displayName: 'Is one of',
    numberOfInputs: 1,
    predicate: (filterValues, cellValue) :boolean =>
      filterValues[0]
        .split(',')
        .map((v) => v.trim())
        .some((value) => cellValue === value),
  },
  NOT_IN: {
    displayKey: 'notIn',
    displayName: 'Is not one of',
    numberOfInputs: 1,
    predicate: (filterValues, cellValue) :boolean =>
      filterValues[0]
        .split(',')
        .map((v) => v.trim())
        .some((value) => cellValue !== value),
  },
};

export const AgGridConstants = {
  DEFAULT_DETAIL_CELL_RENDERER_TEMPLATE,
  filterModelTypeToBackendOperator,
  AdvancedFilterOperatorByAgGridType,
  FilterOption,
};
